// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "1e3d7a6";
